import psHttp from '@patsnap/common-ps-http';
import { coreBasicApiUrlPrefix } from '../../config/constants';
import { get, isEmpty, cloneDeep } from 'lodash';
import qs from 'qs';
import { ANALYTICS_URI } from 'library-@/config/apiConfig';

export function exportInitApi({ params }) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/init`,
        method: 'GET',
        params,
    }).then(({ data }) => {
        return data || {};
    });
}

export function exportResultInitApi({ job_id }) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/result/${job_id}`,
        method: 'GET',
    }).then(({ data }) => {
        return data || {};
    });
}

export function submitExportApi(data) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/submit`,
        method: 'POST',
        data,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getExportDownloadUrlApi({ job_id }) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/download/${job_id}`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function checkExportJobApi({
    job_id,
}) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/check/${job_id}?t=${new Date().getTime()}`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function addExportTemplateApi({
    name,
    fields,
    folder_id,
    workspace_id,
}) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/template`,
        method: 'POST',
        data: {
            name,
            fields,
            folder_id,
            space_id: workspace_id,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function editExportTemplateApi({
    id,
    fields,
    workspace_id,
    folder_id,
}) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/template/${id}`,
        method: 'PUT',
        data: {
            fields,
            space_id: workspace_id,
            folder_id,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function deleteExportTemplateApi({ id }) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/template/${id}`,
        method: 'DELETE',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getJobQueueMessagesApi() {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/job-queue/message`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function goToJobQueueApi({ id }) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/job-queue/goto-job/${id}`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function clearJobQueueApi() {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/job-queue/message-count/clear`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function exportPatentApi({
    params = {},
    data = {},
}) {
    let _data = cloneDeep(data);

    if (get(_data, 'patent_ids.length') === 0) {
        delete _data.patent_ids;
    }

    if (isEmpty(_data)) {
        return Promise.resolve({
            query_string: `${ANALYTICS_URI}/export?${qs.stringify(params)}`,
        });
    }
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/patents/export`,
        method: 'POST',
        data: _data,
        transformCode: true,
    }).then(({ data }) => {
        const query_id = get(data, 'data.query_id') || '';
        return {
            query_string: `${ANALYTICS_URI}/export?${qs.stringify({ ...params, query_id })}`,
        };
    });
}

export function exportSequenceApi({
    extract_type,
    patent_id,
    pn,
    range_start,
    range_end,
    total,
    q
}) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/sequence`,
        method: 'POST',
        data: {
            extract_type,
            total,
            q,
            patent_id,
            pn,
            range_start,
            range_end,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getVerificationInfo() {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/verification-info`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function setVerificationPosition({ x_position, verification_id }) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/verification`,
        method: 'POST',
        data: {
            x_position,
            verification_id
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || false;
    });
}
